import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { AUTHENTICATION_TYPES } from '../types/Authentication';
import type { GetUserInfoQuery } from 'src/types/graphql';
import { GET_USER_QUERY } from 'src/modules/graphql/getUser.graphql';

export function useUserProfile() {
  const { data } = useQuery<GetUserInfoQuery>(GET_USER_QUERY);
  const user = useMemo(() => data?.viewer, [data]);

  // update authenticationStatus when user obj has been updated
  const authenticationStatus = useMemo(
    () =>
      user
        ? AUTHENTICATION_TYPES.AUTHENTICATED
        : AUTHENTICATION_TYPES.UNAUTHENTICATED,
    [user],
  );

  return { user, authenticationStatus };
}
